<template>
    <div class="More" :style="{ 'width': _isMobile() ? '100%' : '1200px' }">
      <div class="mainContent" :style="{borderRadius:_isMobile() ? '28px 28px 0 0' : 'none'}">
        <div class="header">
          <template v-if="_isMobile()">
            更多<i class="iconfont">&#xe63c;</i>
            <img src="../assets/image/JXW.png" class="jxwLogo" alt="">
          </template>
        </div>
        <a-row type="flex" justify="space-between" style="width: 90%;margin: 0 auto;" v-if="menuList.length > 0">
          <a-col v-for="item, index in menuList" :key="index" :xs="11" :sm="11" :md="7" :lg="7" :xl="7">
            <div class="menuList" @click="toPageFn(item.url)" :style="{background:item.background}">
              <div class="left">
                <p class="menuName">{{ item.menuName }}</p>
                <p class="viceMenuName">{{ item.viceMenuName }}</p>
              </div>
              <div class="right">
                <img :src="item.imgUrl" style="width:41px;height: 44px;" alt="">
              </div>
            </div>
          </a-col>
        </a-row>
        <p v-else style="margin: 30px auto;font-size: 18px;text-align: center;">敬请期待</p>
      </div>
    </div>
  </template>
  <script>
  import Banner from '../components/Banner.vue';
  import { mixinDevice } from "@/utils/mixin.js";
  export default {
    name: 'More',
    components: { Banner },
    mixins: [mixinDevice],
    data() {
      return {
        menuList: []
      }
    },
    created() { },
    mounted() { },
    methods: {
      toPageFn(url) {
        this.$router.push({ path: url });
      }
    }
  }
  </script>
  <style lang='scss' scoped>
  .More {
    width: 100%;
    margin:  -28px auto;
  
    .mainContent {
      width: 100%;
      // border-radius: 28px 28px 0 0;
      background: #fff;
      .header{
        width: 100%;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 17px;
        color: #333;
        position: relative;
        .jxwLogo{
          width: 67px;
          height: 70px;
          position: absolute;
          top: -31px;
          right: 13px;
          z-index: 9;
        }
      }
    }
  
    .menuList {
      width: 100%;
      height: 86px;
      padding: 0 14px;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 22px;
  
      .menuName {
        font-size: 19px;
        color: #fff;
        font-weight: normal;
      }
  
      .viceMenuName {
        font-size: 12px;
        color: #000;
        opacity: 0.5;
      }
    }
  }
  </style>
  